import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

export const FlexPageMoveButtonWrapper = styled(Flex)`
  position: static;
  height: 100%;
`;
